import get from 'lodash.get';
export function createInitiatedReducer(statePath) {
  return state => {
    var asyncEntity = get(state, statePath);
    asyncEntity.pending = true;
  };
}